<template>
	<div>ok</div>
</template>
<script>
import {removeUser, removeRedbagUser} from '@/utils/user'
import {removeToken} from '@/utils/auth'

export default {
	created() {
		removeUser()
		removeRedbagUser()
		removeToken()
	}
}

</script>